import { ProblemError, type Words } from "@emdur/ui";

/** A failure as one line for a person: an Error's message (a problem's words, set by the code that threw), or the
 * value itself. */
export const errorText = (error: unknown): string => (error instanceof Error ? error.message : String(error));

/** A failed request as one line: a problem's own words, or, for anything else (offline, blocked), the kit's words
 * for a request that never arrived. */
export const failureText = (error: unknown, words: Pick<Words, "requestUnreachable">): string =>
  error instanceof ProblemError ? error.message : words.requestUnreachable;
